import * as types from "../actions/common.actions";

const INITIAL_STATE = {
  error: null,
  loading: [],
  subHeader: {
    items: []
  },
  headerBar: {}
};

export default function(state = INITIAL_STATE, action = {}) {
  let clonedLoading;

  switch (action.type) {
    case types.SET_ERROR:
      return Object.assign({}, state, { error: action.error });

    case types.SET_LOADING:
      clonedLoading = [].concat(state.loading);
      if (action.loading) {
        clonedLoading.push(true);
      } else {
        clonedLoading.pop();
      }
      return Object.assign({}, state, { loading: clonedLoading });

    case types.SET_SUBHEADER_ITEMS:
      return Object.assign({}, state, { subHeader: action.subHeader });

    case types.SET_HEADER_BAR:
      return Object.assign({}, state, { headerBar: action.headerBar });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/common.reducer.js